(ns ycweb.app.website.dlp.widgets.badgerow
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]))

(rum/defc badge-row < rum/reactive [{:keys [properties]}]
  (let [{:badges/keys [number-of-badges]} properties
        badge-count (u/parseInt number-of-badges)]
    (when (> badge-count 0)
      [:div.yc-section
       (into
         [:ul.group
          {:class (u/bem :product-icons [:center])}]
         (map
           (fn [idx]
             (let [image ((keyword (str "badges/badge-" idx "-public-id")) properties)
                   alt-tag ((keyword (str "badges/badge-" idx "-alt")) properties)]
               [:li.product-icons__item
                [:img
                 {:src
                  (u/cloudinary
                    image
                    {:q "auto" :f "auto"})
                  :class (u/bem :yc-simple-image [:full :center])
                  :alt alt-tag}]]))
           (range 1 (inc badge-count))))])))
